import { DeviceModels, DeviceTypeConfig } from '@eppendorf/app-configs';

import { UpdatedDevice } from '$features/devices/devices.types';

import { useGetDeviceTypeConfigs } from './app-config.api';

/**
 * Return the DeviceTypeConfig for a given device
 * @param device The device information
 * @returns The DeviceTypeConfig for the given model name or null if no DeviceTypeConfig is found
 */
export function useDeviceTypeConfig(
  device?: UpdatedDevice | null,
): DeviceTypeConfig<DeviceModels> | null {
  const { data: deviceTypeConfigs } = useGetDeviceTypeConfigs();

  if (!device || !deviceTypeConfigs) {
    return null;
  }

  const matchedConfig = deviceTypeConfigs.find(
    (c) =>
      c.typeIds?.includes?.(device.type as string) ||
      c.models.includes(device.model as DeviceModels),
  );

  if (!matchedConfig) {
    return null;
  }

  return matchedConfig;
}
